import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import { useFormikContext, useField } from 'formik'
import { ILocationType } from '@user/store/locationTypes/typings'
import { useCallback, useEffect, useMemo } from 'react'

type Props = {
  name: string
  required?: boolean
  locationTypes: ILocationType[]
}

export function useData(props: Props) {
  const { required, name, locationTypes } = props

  const options = locationTypes

  const {
    setFieldValue,
    isSubmitting,
    values: { locationTypeId, billTo_locationTypeId },
  } = useFormikContext<ILeadFormModel>()

  const currentValue = useMemo(
    () => (name == 'locationTypeId' ? locationTypeId : billTo_locationTypeId),
    [name, locationTypeId, billTo_locationTypeId],
  )

  const [{}, { error, touched }] = useField<string>({
    name,
    validate: (value) => {
      if (required && !value) {
        return 'Required'
      }
    },
  })

  const showError = Boolean(error && touched)
  const helperText = showError ? error : ''

  const getLabel = useCallback(
    (option: ILocationType) =>
      option.description.trim() == ''
        ? option.name
        : `${option.name}- ${option.description}`,
    [],
  )

  const getId = useCallback((option: ILocationType) => {
    return String(option.id)
  }, [])

  useEffect(() => {
    if (!currentValue && required && options?.length == 1) {
      setFieldValue(name, options[0].id)
    }
  }, [currentValue, required, setFieldValue, options, name])

  const initialOption = useMemo(() => {
    if (currentValue) {
      const value = options.find((x) => x.id === currentValue)
      if (value) return value
    }
    return null
  }, [options, currentValue])

  return {
    getLabel,
    getId,
    items: options,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  }
}
